// Use relative URL so it works with both HTTP and HTTPS
const BASE_URL = '/api';

export { BASE_URL };
